import React from "react"
import i18n from "@/i18n"
import TabbMark from "./tabb_mark"

const STYLES = {
  cardMobile: "flex flex-col items-center gap-3 rounded-[10px] bg-neutral-800 px-5 py-3",
  cardDesktop: "flex flex-col items-center gap-3",
  subtitleMobile: "text-xs text-neutral-300",
  subtitleDesktop: "text-sm text-neutral-300",
  title: "text-sm font-semibold text-white",
  button:
    "flex items-center gap-[5px] rounded-[5px] bg-white px-[10px] py-[6px] disabled:cursor-default disabled:opacity-100",
  brandName: "text-xs font-semibold text-neutral-900",
  brandLabel: "text-xs text-neutral-900",
} as const

type CtaCardProps = {
  variant: "mobile" | "desktop"
}

const CtaCard: React.FC<CtaCardProps> = ({ variant }) => {
  const t = (key: string) => i18n.t(`app.public.venue.footer.${key}`)

  const cardClass = variant === "mobile" ? STYLES.cardMobile : STYLES.cardDesktop

  const subtitleClass = variant === "mobile" ? STYLES.subtitleMobile : STYLES.subtitleDesktop

  return (
    <div className={cardClass}>
      <div>
        <p className={STYLES.title}>{t("run_a_venue")}</p>
        <p className={subtitleClass}>{t("cta_subtitle")}</p>
      </div>
      <button type="button" disabled className={STYLES.button}>
        <TabbMark />
        <span>
          <span className={STYLES.brandName}>{t("tabb_brand")}</span>{" "}
          <span className={STYLES.brandLabel}>{t("tabb_for_business")}</span>
        </span>
      </button>
    </div>
  )
}

export default CtaCard
